import {createSelector} from 'reselect'
import {CurrencyVal, ProductType, ProductTypeVal} from '@modifi/enums'
import {selectFinancingOptions} from '../../data/financing-options'

export const selectAvailableSellerBankAccountCurrencies = createSelector(
  selectFinancingOptions,
  (
    financingOptions: {
      sellerBankAccount?: any
      productType?: ProductTypeVal
      externalId?: string
      settlementCurrency?: CurrencyVal
    }[]
  ) =>
    financingOptions
      ?.filter(
        option => !option.sellerBankAccount && option.productType === ProductType.SELLER_FINANCING
      )
      ?.map(option => ({
        settlementCurrency: option.settlementCurrency!,
        externalId: option.externalId!,
      })) ?? []
)
